export const LOGO_CLASS_NAME = 'transition-all duration-300 ease-out';
